import { useQuery } from '@tanstack/react-query';
import { queryKeys, pimsService } from '@v2/services';
import type { Pims } from '@v2/types';

interface UsePimsResult {
  pims: Pims[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const usePims = (): UsePimsResult => {
  const query = useQuery({
    queryKey: queryKeys.pims.lists(),
    queryFn: pimsService.getPims,
  });

  return {
    pims: query.data ?? [],
    loading: query.isLoading,
    error: query.error instanceof Error ? query.error.message : null,
    refetch: async () => {
      await query.refetch();
    },
  };
};

export default usePims;
